module.exports = __webpack_public_path__ + "512efb4455f83193c69d3f6d80396cfd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/iconfont.ttf
// module id = 353
// module chunks = 0 204 209